import dt from '../../node_modules/styled-components/dist/styled-components.browser.esm.js';

const createImageIcon = (src, size) => {
  return dt.img.attrs((p) => {
    return {
      ...p,
      src,
      height: size,
      width: size,
      draggable: false
    };
  }).withConfig({
    displayName: "image__createImageIcon",
    componentId: "sc-73b693c8-0"
  })([
    `height:`,
    `px;width:`,
    `px;max-height:`,
    `px;max-width:`,
    `px;`
  ], size, size, size, size);
};

export { createImageIcon };
//# sourceMappingURL=image.js.map
